import { createRouter, createWebHashHistory } from 'vue-router'
import Page from '../components/core/Page.vue'

const routes = [
  { path: "/:id*", component: Page }
]


const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 0)
      })
    } else {
      return { top: 0 }
    }
  }
})


// Page navigation tracking hook
router.beforeEach((to, from, next) => {
  var data = {to: to.fullPath, from: from.fullPath};
  app.api.Tracking.navigation("navigation", to.fullPath, data);
  next();
})

export default router
